import { FC } from 'react';
import { Th } from '@chakra-ui/react';

export const TableHeader: FC<{ title: string }> = ({ title }) => {
  return (
    <Th
      border="none"
      color="custom_blue.1"
      fontWeight="medium"
      fontSize="xs"
      letterSpacing="normal"
      textTransform="none"
    >
      {title}
    </Th>
  );
};
